export type AuthGuardDecision = 'pending' | 'redirect' | 'allow';

export function getAuthGuardDecision(
  isInitialized: boolean,
  isLoggedIn: boolean,
): AuthGuardDecision {
  if (!isInitialized) return 'pending';
  return isLoggedIn ? 'allow' : 'redirect';
}

export function getLoginReturnPath(pathname: string, search: string): string {
  return `${pathname}${search}`;
}
